import GETJwtToken from "./authentication";

/**
 * Reuses REST authentication and returns the bare JWT for the bearer subprotocol.
 */
const GETJwtTokenSocket = async (): Promise<string> => {
  const token = (await GETJwtToken()).replace(/^Bearer\s+/i, "");

  if (!token) {
    throw new Error("[GETJwtTokenSocket] no JWT available for the monitoring WebSocket handshake");
  }

  return token;
};

export default GETJwtTokenSocket;
